<template>
  <div class="loader" v-if="this.$store.state.loading">
    <div class="loader-background-illustration loader-background-illustration--top" :style="'background-image: url(/app/images/objects/festive-decoration.svg);'"></div>
    <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#0F9B0D">
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
          <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
          </path>
        </g>
      </g>
    </svg>
    <div class="loader-background-illustration loader-background-illustration--bottom" :style="'background-image: url(/app/images/objects/festive-decoration.svg);'"></div>
  </div>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Preloader',
  mixins: [Default],
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.loader {
  background-color: $white;

  .loader-background-illustration {
    position: absolute;
    right: 0;
    left: 0;
    width: 100%;
    height: 36px;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;

    // Mobile
    @include media-breakpoint-down(sm) {
      height: 18px;
    }

    &--top {
      top: 0;
    }

    &--bottom {
      bottom: 0;
    }
  }
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Preloader.vue